/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Three_KkInputs */

const cs_enum_three_kk = /** @type {(inputs: Enum_Three_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3+kk`)
};

const en_enum_three_kk = /** @type {(inputs: Enum_Three_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3+kk`)
};

/**
* | output |
* | --- |
* | "3+kk" |
*
* @param {Enum_Three_KkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_three_kk = /** @type {((inputs?: Enum_Three_KkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Three_KkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_three_kk(inputs)
	return cs_enum_three_kk(inputs)
});